import signUpServices from '@/services/signup.js'

const signUpHandler = {
  state: {
    countryName: [],
    countryCurrency: [],
    countryNameCode: [],
    stateList: []
  },

  mutations: {
    MUTATION_GET_COUNTRY_NAME (state, payload) {
      state.countryName = payload
      // payload.forEach(function (item) {
      //   state.countryCurrency.push(item.currencies[0])
      // })
      payload.forEach(function (item) {
        state.countryNameCode.push(item.name + ' +' + item.phone)
      })
    },
    MUTATION_GET_COUNTRY_STATE (state, payload) {
      state.stateList = payload || []
    },
    MUTATION_USER_REGISTER (state, payload) {
    }
  },

  actions: {
    async ACTION_GET_STATIC_PAGE (context, page) {
      let response = await signUpServices.getPage(page)
      return response
    },
    async ACTION_GET_COUNTRY_NAME (context) {
      let getCountryNames = await signUpServices.getCountries()
      context.commit('MUTATION_GET_COUNTRY_NAME', getCountryNames)
      return getCountryNames
    },
    async ACTION_GET_COUNTRY_STATE (context, payload) {
      context.commit('MUTATION_GET_COUNTRY_STATE', await signUpServices.getStatesByCountryCode(payload))
      return Promise.resolve()
    },
    async ACTION_USER_REGISTER (context, payload) {
      context.commit('MUTATION_USER_REGISTER', await signUpServices.userRegister(payload))
      return Promise.resolve()
    },
    async ACTION_INIT_ACCOUNT (context, payload) {
      let req = await signUpServices.initAccount(payload)
      return Promise.resolve(req)
    },
    async ACTION_VERIFY_EMAIL (context, payload) {
      let req = await signUpServices.verifyEmail(payload)
      return Promise.resolve(req)
    },
    async ACTION_VERIFY_UPDATE_EMAIL (context, payload) {
      let req = await signUpServices.verifyEmailUpdate(payload)
      return Promise.resolve(req)
    },
    async ACTION_VERIFY_OTP (context, payload) {
      let req = await signUpServices.verifyOTP(payload)
      return Promise.resolve(req)
    },
    async ACTION_VALIDATE_MOBILE (context, payload) {
      let req = await signUpServices.validateMobile(payload)
      return Promise.resolve(req)
    },
    async ACTION_RESEND_EMAIL (context, payload) {
      let req = await signUpServices.resendEmail(payload)
      return Promise.resolve(req)
    },
    async ACTION_RESEND_SIGNUP_OTP (context, payload) {
      let req = await signUpServices.resendOTP(payload)
      return Promise.resolve(req)
    },
    async ACTION_COMPLETE_ACCOUNT (context, payload) {
      let req = await signUpServices.completeAccount(payload)
      return Promise.resolve(req)
    },
    async ACTION_COMPLETE_ACCOUNT_V2 (context, payload) {
      let req = await signUpServices.completeAccountV2(payload)
      return Promise.resolve(req)
    },
    async ACTION_TWO_FACTOR_AUTH (context, payload) {
      let req = await signUpServices.twoFactorAuth(payload)
      return req
    },
    async ACTION_RESEND_OTP (context, payload) {
      let req = await signUpServices.resendTwoFaOTP(payload)
      return req
    },
    async ACTION_UPDATE_TAX_CATEGORY (context, payload) {
      let response = await signUpServices.updateTaxCategory(payload)
      return response
    },
    async ACTION_INIT_ACCOUNT_V2 (context, payload) {
      let req = await signUpServices.initAccountV2(payload)
      return Promise.resolve(req)
    },
    async ACTION_GET_CURRENCY_LIST () {
      let response = await signUpServices.getCurrencyList()
      return response
    },
  },

  getters: {
    getCountryName: state => state.countryName,
    getCountryCurrency: state => state.countryCurrency,
    getCountryNameWithCode: state => state.countryNameCode,
    getCountryState: state => state.stateList
  }
}

export default signUpHandler
